<mat-form-field class="multi-labels">
  <mat-label>{{ placeholder }}</mat-label>
  <mat-chip-grid #chipList aria-label="Label selection">
    @for (label of labels; track label) {
      <mat-chip-row [removable]="!readOnly" (removed)="remove(label)">
        {{ searchKey ? label[searchKey] : label }}
        @if (optionBadgeFn) {
          @let badge = optionBadgeFn(label);
          @if (badge) {
            <span class="campaign-badge" [ngClass]="badge.cssClass">{{ badge.text }}</span>
          }
        }
        @if (!readOnly) {
          <mat-icon matChipRemove>cancel</mat-icon>
        }
      </mat-chip-row>
    }
    <input #labelInput [formControl]="labelCtrl" #trigger="matAutocompleteTrigger" [placeholder]=""
      [matAutocomplete]="auto" [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="add($event)" (focus)="onOpened($event)">
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" [displayWith]="displayFn.bind(this)">
    @for (label of filteredLabels | async; track label) {
      <mat-option [value]="label">
        <span class="option-row">
          {{ searchKey ? label[searchKey]: label }}
          @if (optionBadgeFn) {
            @let badge = optionBadgeFn(label);
            @if (badge) {
              <span class="campaign-badge" [ngClass]="badge.cssClass">{{ badge.text }}</span>
            }
          }
        </span>
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>